const amazonDomainFlags = {
  'com': 'ארה"ב', // United States
  'uk': 'בריטניה', // United Kingdom
  'co.uk': 'בריטניה', // United Kingdom
  'de': 'גרמניה', // Germany
  'fr': 'צרפת', // France
  'it': 'איטליה', // Italy
  'es': 'ספרד', // Spain
  'jp': 'יפן', // Japan
};

export default amazonDomainFlags; 